export const FormCreateDataEquipment = {
  id: null,
  name: null,
  name_touched: false,
  type: null,
  type_touched: false,
  active: false,
  deleted: false,
  duplicate: false,
  is_touched: false,
  action: null,
};
export const FormCreateDataFuel = {
  id: null,
  name: null,
  name_touched: false,
  active: false,
  deleted: false,
  duplicate: false,
  is_touched: false,
  action: null,
};

export const FormValidasiDataEquipment = {
  name: [(v) => !!v?.trim() || "Nama peralatan harus diisi"],
  type: [(v) => !!v || "Kategori tidak valid"],
};
export const FormValidasiDataFuel = {
  name: [(v) => !!v?.trim() || "Nama bahan bakar harus diisi"],
  type: [(v) => !!v || "Kategori tidak valid"],
};

export const AsignFormDataSysConfig = (oldData, newData) => {
  oldData.id_fuel = newData.id_fuel;
  oldData.biofuel = newData.biofuel;
  oldData.bbm_fosil = newData.bbm_fosil;
  oldData.density_biofuel = newData.density_biofuel;
  oldData.density_bbm_fosil = newData.density_bbm_fosil;
  oldData.calorie_value_biofuel = newData.calorie_value_biofuel;
  oldData.calorie_value_bbm_fosil = newData.calorie_value_bbm_fosil;
  oldData.faktor_emisi_biofuel = newData.faktor_emisi_biofuel;
  oldData.faktor_emisi_bbm_fosil = newData.faktor_emisi_bbm_fosil;
  oldData.koefisien_biofuel = newData.koefisien_biofuel;
  oldData.koefisien_bbm_fosil = newData.koefisien_bbm_fosil;
  oldData.gwp = newData.gwp;
  oldData.factor_ipcc_2019_biofuel = newData.factor_ipcc_2019_biofuel;
  oldData.factor_ipcc_2019_bbm_fosil = newData.factor_ipcc_2019_bbm_fosil;

  return oldData;
};

export const FormValidasiDataSysConfig = {
  biofuel: [
    (v) => !!v?.trim() || "biofuel harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "biofuel tidak boleh berakhir dengan koma.",
  ],
  bbm_fosil: [
    (v) => !!v?.trim() || "BBM fosil harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "BBM fosil tidak boleh berakhir dengan koma.",
  ],
  density_biofuel: [
    (v) => !!v?.trim() || "Density biofuel harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Density biofuel tidak boleh berakhir dengan koma.",
  ],
  density_bbm_fosil: [
    (v) => !!v?.trim() || "Density BBM fosil harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Density BBM fosil tidak boleh berakhir dengan koma.",
  ],
  calorie_value_biofuel: [
    (v) => !!v?.trim() || "Calorie Value biofuel harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Calorie Value biofuel tidak boleh berakhir dengan koma.",
  ],
  calorie_value_bbm_fosil: [
    (v) => !!v?.trim() || "Calorie Value BBM fosil harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Calorie Value BBM fosil tidak boleh berakhir dengan koma.",
  ],
  faktor_emisi_biofuel: [
    (v) => !!v?.trim() || "Faktor Emisi biofuel harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor Emisi biofuel tidak boleh berakhir dengan koma.",
  ],
  faktor_emisi_bbm_fosil: [
    (v) => !!v?.trim() || "Faktor Emisi BBM fosil harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor Emisi BBM Fosil tidak boleh berakhir dengan koma.",
  ],
  koefisien_biofuel: [
    (v) => !!v?.trim() || "Koefisien biofuel harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Koefisien biofuel tidak boleh berakhir dengan koma.",
  ],
  koefisien_bbm_fosil: [
    (v) => !!v?.trim() || "Koefisien BBM fosil harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Koefisien BBM fosil tidak boleh berakhir dengan koma.",
  ],
  gwp: [
    (v) => !!v?.trim() || "GWP harus diisi",
    (v) =>
      !String(v || "").endsWith(",") || "GWP tidak boleh berakhir dengan koma.",
  ],
  factor_ipcc_2019_biofuel: [
    (v) => !!v?.trim() || "Faktor IPPC 2019 biofuel harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor IPPC 2019 biofuel tidak boleh berakhir dengan koma.",
  ],
  factor_ipcc_2019_bbm_fosil: [
    (v) => !!v?.trim() || "Faktor IPPC 2019 BBM fosil harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor IPPC 2019 BBM fosil tidak boleh berakhir dengan koma.",
  ],
};
